// extracted by mini-css-extract-plugin
export default {"image":"styles_image__ODZlc","limitations":"styles_limitations__pf0st","limitation":"styles_limitation__Rx9lG"};